<template>
  <div class="mt-6" :class="disabled ? 'disabled-node' : ''">
    <div v-for="symptom in symptomOptions()" :key="symptom.key" class="mb-4">
      <SkinProblemRow
        :label="symptom.label"
        :mobile="isMobile"
        :levels-length="4"
        v-model="modelValue[symptom.key].value"
        mode="images"
      >
        <template #levels="level">
          <div class="p-relative">
            <v-img
              :lazy-src="imageFallback"
              :src="`${baseImageUrl}/paola-assets/${symptom.asset}/${level.value}.png`"
              :max-width="isMobile ? 64 : 88"
              aspect-ratio="1"
              class="click-img skin rounded-lg"
              eager
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-icon :size="16" class="expand-icon" @click.stop="(e) => expandImg(level, symptom)">
              mdi-arrow-top-right-bottom-left
            </v-icon>
          </div>
        </template>

        <template #label="level">
          <div :class="['caption font-weight-medium font-size-12', isMobile ? 'mobile' : '']">
            <span>{{ level.value }}</span>
            <span v-if="!isMobile">&nbsp;-&nbsp;</span>
            <span>{{ level.label }}</span>
          </div>
        </template>
      </SkinProblemRow>
    </div>
    <ImgModal v-model="showImgModal" ref="imgModal" :levels-to-show="4" :use-normal-skin="false" />
  </div>
</template>

<script>
import { PLACEHOLDER_AVATAR_PATH, PUBLIC_STORAGE_URL } from '@/constants/global'
import ImgModal from '@/components/CalculatorContent/partial/ImgModal.vue'
import SkinProblemRow from '@/components/CalculatorContent/partial/SkinProblemRow.vue'
import { SYMPTOMS } from '@/components/NewAttendanceForm/AtopicDermatitis/FormNodes/Scores/symptomlevel'
import { cloneDeep, isEmpty } from 'lodash'

export default {
  name: 'AtopicDermatitisSymptomLevel',
  components: { SkinProblemRow, ImgModal },
  props: {
    /** @type {PropOptions<any>} */
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const baseValue = {
      liquenificacao: {
        value: null,
      },
      eritema: {
        value: null,
      },
      edema: {
        value: null,
      },
      exsudacao: {
        value: null,
      },
      escoriacoes: {
        value: null,
      },
      xerose: {
        value: null,
      },
    }
    const modelValue = isEmpty(this.value) ? baseValue : cloneDeep(this.value)

    return {
      modelValue,
      showImgModal: false,
      baseImageUrl: PUBLIC_STORAGE_URL,
      imageFallback: PLACEHOLDER_AVATAR_PATH,
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown || this.mobile
    },
  },
  watch: {
    /** @type {WatchOptionsWithHandler<ModelValue>} */
    modelValue: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    symptomOptions() {
      return SYMPTOMS
    },
    expandImg(level, symptom) {
      this.$refs.imgModal.setImgByLevel(level.key, symptom.asset)
      this.showImgModal = true
    },
  },
}
</script>

<style scoped>
:deep(.v-image.skin .v-responsive__content) {
  width: 250px;
}

.click-img:hover {
  cursor: pointer;
}

.click-img::after {
  content: '';
  position: absolute;
  display: block;
  height: 100%;
  width: 100%;
  top: 0;
  opacity: 0;
  box-shadow: inset 0px 0px 0px 2px #006cd0;
  border-radius: 8px;
  transition: all 150ms;
}

.click-img:hover::after {
  opacity: 1;
}

.expand-icon {
  background: #ffffffcc;
  border-radius: 50%;
  padding: 8px;
  margin: 4px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}

.expand-icon.mobile {
  padding: 4px;
}

.expand-icon:hover {
  background: #ffffff82;
}
</style>
